'use client';

import { Box, Typography, Paper, Stack, Button } from '@mui/material';
import { LocalOffer as OfferIcon } from '@mui/icons-material';
import { useTranslation } from '@/kit/useTranslation';

export default function OffersCard({ offers = [] }) {
  const { t } = useTranslation();
  return (
    <Box>
      <Typography
        sx={{
          fontSize: '0.65rem',
          fontWeight: 800,
          mb: 1.25,
          color: '#94a3b8',
          letterSpacing: 0.5,
        }}
      >
        {t('bulkBooking.offersAndPlans')}
      </Typography>
      <Stack spacing={1}>
        {(offers.length
          ? offers
          : [
              {
                id: 'o1',
                title: t('bulkBooking.defaultOfferTitle'),
                desc: t('bulkBooking.defaultOfferDesc'),
              },
            ]
        ).map((o) => (
          <Paper
            key={o.id}
            elevation={0}
            sx={{
              p: 1.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderRadius: 2,
              border: '1px solid #f1f5f9',
              bgcolor: '#fefaf3',
              transition: 'all 220ms',
              '&:hover': {
                transform: 'translateY(-3px)',
                boxShadow: '0 4px 16px rgba(245,158,11,0.15)',
                borderColor: '#f59e0b',
              },
            }}
          >
            <Box sx={{ flex: 1, pr: 1.5 }}>
              <Typography
                sx={{
                  fontSize: '0.8rem',
                  fontWeight: 700,
                  color: '#111827',
                  lineHeight: 1.3,
                  mb: 0.25,
                }}
              >
                {o.title}
              </Typography>
              <Typography
                sx={{
                  fontSize: '0.68rem',
                  color: '#6b7280',
                  fontWeight: 500,
                }}
              >
                {o.desc}
              </Typography>
            </Box>
            <Button
              size="small"
              variant="contained"
              sx={{
                textTransform: 'none',
                bgcolor: '#f59e0b',
                fontSize: '0.7rem',
                fontWeight: 700,
                px: 1.75,
                py: 0.5,
                minWidth: 65,
                boxShadow: 'none',
                '&:hover': {
                  bgcolor: '#d97706',
                  boxShadow: '0 2px 8px rgba(245,158,11,0.3)',
                },
              }}
            >
              {t('bulkBooking.applyOffer')}
            </Button>
          </Paper>
        ))}
      </Stack>
    </Box>
  );
}
